/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { SearchResult } from 'functions/src/types/firestore/Search';
import { GameSearchResult } from './search-results/GameSearchResult';
import { ProfileSearchResult } from './search-results/ProfileSearchResult';
import { ReviewSearchResult } from './search-results/ReviewSearchResult';
import { ArticleSearchResult } from './search-results/ArticleSearchResult';
import { CompetitionSearchResult } from './search-results/CompetitionSearchResult';
import { useMemo } from 'react';
import { ItemSearchResult } from './search-results/ItemSearchResult';
import { AnnouncementSearchResult } from './search-results/AnnouncementResult';

export type SearchResultCardProps = {
  searchResult: SearchResult;
};

export const CATEGORY_MAP = {
  game: GameSearchResult,
  profile: ProfileSearchResult,
  competition: CompetitionSearchResult,
  item: ItemSearchResult,
  review: ReviewSearchResult,
  article: ArticleSearchResult,
  announcement: AnnouncementSearchResult,
};
//TODO: to add news and other search results.
export const SearchResultCard = ({ searchResult }: SearchResultCardProps) => {
  const theme = useTheme();

  const SearchResultComponent = useMemo(
    () => CATEGORY_MAP[searchResult.category],
    [searchResult.category],
  );
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        border: `double ${
          searchResult.category === 'item' &&
          searchResult.item?.rarity !== 'common'
            ? '2px'
            : '1px'
        } transparent`,
        borderRadius: '8px',
        backgroundImage:
          searchResult.category === 'item' && searchResult?.item?.rarity
            ? `linear-gradient(${theme.palette.background.elevationSolid[10]},
            ${theme.palette.background.elevationSolid[10]}), ${
                theme.palette.rarityBackground[searchResult?.item?.rarity]
              }`
            : `linear-gradient(${theme.palette.background.elevationSolid[10]},
              ${theme.palette.background.elevationSolid[10]}), linear-gradient(180deg, #4DC8FF 0%, #0064E9 100%)
        `,
        backgroundOrigin: 'border-box',
        backgroundClip: 'content-box, border-box',
        //boxShadow: theme.shadows[4],
        '&:hover': {
          boxShadow: theme.shadows[7],
        },
      }}
    >
      <SearchResultComponent {...(searchResult as any)} />
    </Box>
  );
};
